package com.milta.core.localization.translations.de

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Mein Profil",
    sectionPersonal = "Persönliche Angaben",
    labelFirstName = "Vorname",
    labelLastName = "Nachname",
    labelRole = "Rolle",
    sectionLanguage = "Sprache",
    labelLanguage = "App-Sprache",
    changeLanguageButton = "Sprache ändern",
    languageDialogTitle = "Wählen Sie Ihre Sprache",
    languageDialogConfirm = "Bestätigen",
    languageDialogCancel = "Abbrechen",
    sectionPassword = "Sicherheit",
    labelCurrentPassword = "Aktuelles Passwort",
    labelNewPassword = "Neues Passwort",
    changePasswordButton = "Passwort ändern",
    successLanguageUpdated = "Sprache erfolgreich aktualisiert",
    successPasswordChanged = "Passwort erfolgreich geändert",
    errorProfileNotFound = "Profil nicht gefunden",
    errorCurrentPasswordRequired = "Bitte geben Sie Ihr aktuelles Passwort ein",
    errorCurrentPasswordTooLong = "Das aktuelle Passwort darf nicht länger als 128 Zeichen sein",
    errorNewPasswordRequired = "Bitte geben Sie ein neues Passwort ein",
    errorNewPasswordTooShort = "Das neue Passwort muss mindestens 8 Zeichen enthalten",
    errorNewPasswordTooLong = "Das neue Passwort darf nicht länger als 128 Zeichen sein",
    errorLanguageRequired = "Bitte wählen Sie eine Sprache aus",
    errorForbidden = "Sie sind nicht berechtigt, diese Aktion durchzuführen",
    errorValidation = "Die angegebenen Daten sind ungültig",
    errorGeneric = "Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.",
    signOut = "Abmelden",
    deleteAccount = "Mein Konto löschen",
    menuLanguage = "Oberflächensprache",
    menuPassword = "Passwort ändern",
    menuSubscription = "Mein Abonnement",
    menuPrivacy = "Datenschutz & DSGVO",
    menuTerms = "Nutzungsbedingungen",
    legalUpdatedAtPrefix = "Zuletzt aktualisiert am",
    linkedCodeLabel = "Einmaliger Verknüpfungscode",
    linkedCodeLoadError = "Der Verknüpfungscode konnte nicht geladen werden. Bitte versuche es später erneut.",
    copyCode = "Kopieren",
    codeCopied = "Kopiert!",
    modeOrganisation = "Unternehmen",
    modeDriver = "Fahrer",
    roleDriver = "Fahrer",
    roleOrganisation = "Unternehmen",
    modeSwitchTitle = "Modus wechseln",
    modeSwitchHint = "Wechseln Sie jederzeit zwischen dem Modus Unternehmen und dem Modus Fahrer",
    switchToEnterprise = "Modus Unternehmen",
    switchToDriver = "Modus Fahrer",
    menuPhone = "Telefonnummer",
    phoneOtpStepTitle = "Verifizierungscode per SMS gesendet",
    successPhoneUpdated = "Telefonnummer aktualisiert",
    deleteAccountDialogTitle = "Ihr Konto löschen?",
    deleteAccountDialogMessage = "Diese Aktion kann nicht rückgängig gemacht werden. Ihre persönlichen Angaben werden gelöscht. Zur Bestätigung wird Ihnen ein Verifizierungscode per SMS gesendet.",
    deleteAccountDialogConfirm = "Fortfahren",
    deleteAccountOtpStepTitle = "Verifizierungscode per SMS gesendet",
    deleteAccountConfirmButton = "Endgültig löschen",
    errorLastEnterpriseOwner = "Sie sind der einzige Manager Ihres Unternehmens. Fügen Sie ein weiteres Unternehmenskonto hinzu, bevor Sie Ihres löschen.",
    logoutPendingWarningTitle = "Nicht gesendete Zustellungen",
    logoutPendingWarningMessageSuffix = "ausstehende Zustellung(en) gehen verloren, wenn Sie sich jetzt abmelden.",
    logoutPendingWarningConfirm = "Trotzdem abmelden",
    logoutPendingWarningCancel = "Abbrechen",
    modeSwitchActiveRouteWarningTitle = "Tour läuft",
    modeSwitchActiveRouteWarningMessage = "Derzeit läuft eine Tour. Der Moduswechsel entfernt Sie von deren Verfolgung. Fortfahren?",
    modeSwitchActiveRouteWarningConfirm = "Trotzdem wechseln",
    modeSwitchActiveRouteWarningCancel = "Abbrechen",
)
